// ============================================================================
// DASHBOARD SERVICE — Phase 1 skeleton
// ============================================================================
// All endpoints are POST + body. Backend currently returns HTTP 501
// (NotImplementedException) — the UI surfaces this as "Coming in Phase N".

import { post } from '../client/axiosClient';
import { dashboardEndpoints } from '../endpoints';
import type {
  ApiResponse,
  DashboardFilter,
  BookingOverviewWidget,
  RevenueWidget,
  ApprovalWidget,
  ForwardOccupancyWidget,
  AgentCorporateWidget,
} from '../types';

class DashboardService {
  async getBookingOverview(filter: DashboardFilter): Promise<ApiResponse<BookingOverviewWidget>> {
    const response = await post<ApiResponse<BookingOverviewWidget>>(
      dashboardEndpoints.bookingOverview(),
      filter,
    );
    return response.data;
  }

  async getRevenue(filter: DashboardFilter): Promise<ApiResponse<RevenueWidget>> {
    const response = await post<ApiResponse<RevenueWidget>>(
      dashboardEndpoints.revenue(),
      filter,
    );
    return response.data;
  }

  async getApproval(filter: DashboardFilter): Promise<ApiResponse<ApprovalWidget>> {
    const response = await post<ApiResponse<ApprovalWidget>>(
      dashboardEndpoints.approval(),
      filter,
    );
    return response.data;
  }

  async getForwardOccupancy(filter: DashboardFilter): Promise<ApiResponse<ForwardOccupancyWidget>> {
    const response = await post<ApiResponse<ForwardOccupancyWidget>>(
      dashboardEndpoints.forwardOccupancy(),
      filter,
    );
    return response.data;
  }

  async getAgentCorporate(filter: DashboardFilter): Promise<ApiResponse<AgentCorporateWidget>> {
    const response = await post<ApiResponse<AgentCorporateWidget>>(
      dashboardEndpoints.agentCorporate(),
      filter,
    );
    return response.data;
  }
}

export const dashboardService = new DashboardService();
export default dashboardService;
